import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'setNameDisplay',
  standalone: true,
  pure: true,
})
export class SetNameDisplayPipe implements PipeTransform {
  transform(name: string | undefined | null): string {
    if (!name) return '';

    switch (name.toLowerCase()) {
      case 'execution':
        return 'KNOWLEDGE.HEADER_GENERAL.STATUS_EXECUTION';
      case 'cross-cutting':
        return 'LESSONS.CROSSCUTTING.CROSSCUTTING_TITLE';
      default:
        return name;
    }
  }
}
